function initColorOptions() {
  const $colorOptionContainers = $('.color-options-container');
  
  $colorOptionContainers.each(function() {
    const $container = $(this);
    const $moreButton = $container.find('.color-options-more');
    const $customOptions = $container.find('.option-item:not(:has(input[name="Color"][value*="(In Stock)"])');
    if ($customOptions.length > 6) {
      // Hide options beyond the first 6
      $customOptions.slice(6).hide();
      
      // Show the more button
      if ($moreButton.length > 0) {
        $moreButton.show();
        // JRH Adjusted removed "More"
        $moreButton.text(`+${$customOptions.length - 6}`);
        
        $moreButton.on('click', function() {
          $customOptions.show();
          $(this).hide();
        });
      }
    } else {
      // Hide the more button if there are 6 or fewer options
      if ($moreButton.length > 0) {
          $moreButton.hide();
      }
    }
    // JRH Adjusted from "flex" to "grid"
    $container.css('display', 'grid');
  });
}

// Initialize when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initColorOptions);
} else {
  initColorOptions();
} 